/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TierDictionaryDto = {
    key?: TierDictionaryDto.key;
    displayValue?: string;
    teamType?: TierDictionaryDto.teamType;
};
export namespace TierDictionaryDto {
    export enum key {
        EKSTRAKLASA = 'EKSTRAKLASA',
        FIRST_LEAGUE = 'FIRST_LEAGUE',
        SECOND_LEAGUE = 'SECOND_LEAGUE',
        THIRD_LEAGUE = 'THIRD_LEAGUE',
        FOURTH_LEAGUE = 'FOURTH_LEAGUE',
        FIFTH_LEAGUE = 'FIFTH_LEAGUE',
        REGIONAL_CLASS = 'REGIONAL_CLASS',
        CLASS_A = 'CLASS_A',
        CLASS_B = 'CLASS_B',
        CLASS_C = 'CLASS_C',
        CLJ = 'CLJ',
        VOIVODESHIP_I = 'VOIVODESHIP_I',
        VOIVODESHIP_2 = 'VOIVODESHIP_2',
        VOIVODESHIP_3 = 'VOIVODESHIP_3',
        REGIONAL = 'REGIONAL',
    }
    export enum teamType {
        SENIOR = 'SENIOR',
        YOUTH = 'YOUTH',
    }
}

